import z from "zod";

export const VacancySchema = z.object({
    id: z.string(),
    name: z.string(),
    description: z.string().nullable().optional(),
    employmentType: z.string().nullable().optional(),
    workSchedule: z.string().nullable().optional(),
    salary: z.string().nullable().optional()
});
export type VacancyDTO = z.infer<typeof VacancySchema>;

export const VacancyOptimizedSchema = z.object({
    id: z.string(),
    name: z.string(),
});
export type VacancyOptimizedDTO = z.infer<typeof VacancyOptimizedSchema>;
